
import { Component, Prop, Mixins } from 'vue-property-decorator';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';
@Component
export default class ThemedSheet extends Mixins(DarkThemeInfoMixin) {

    @Prop({ default: 1 }) readonly level!: number;
    themeColors: any = {
        dark: {
            color: 'grey',
            teint: 'darken',
            teintLevel: {
                1: 1,
                2: 2,
                3: 3,
                4: 4,
            },
        },
        light: {
            color: 'white',
            teint: 'lighten',
            teintLevel: {
                1: 4,
                2: 3,
                3: 4,
                4: 1,
            },
        },
    };
    get color() {
        if (!this.level) {
            return '';
        }
        const themeColor = this.isDarkModeActive ? this.themeColors.dark : this.themeColors.light;
        const color = themeColor.color;
        const teint = themeColor.teint;
        const teintLevel = themeColor.teintLevel[this.level];
        return `${color} ${teint}-${teintLevel}`;
    }
}
